export default __webpack_public_path__ + "static/media/Montserrat-Regular.ceb11275.ttf";